export const removeTimezone = (date: Date): Date => {
  return new Date(date.getTime() + date.getTimezoneOffset() * 60_000);
};
